import * as ActionTypes from './actions';

const initialState = [
	{
		id: 1,
		name: 'English',
		culture: 'en-GB',
		image: 'flag-gb.svg',
		isDefault: true,
		isActive: false
	}
];

const language = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.LANGUAGES_SUCCESS:
			const allLanguages = action.response;

			return allLanguages.map(language => ({
				...language,
				image: `flag-${language.culture.substring(language.culture.length - 2).toLowerCase()}.svg`,
				isActive: language.isDefault
			}));
		case ActionTypes.CHANGE_LANGUAGE:
			return state.map(lang => ({ ...lang, isActive: lang.culture === action.culture }));
		default:
			return state;
	}
};

export default language;

export const getActiveLanguage = languages => languages.find(x => x.isActive);